import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useTrendingBooks = (queryParams) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;
		const res = await instance.get("books/trending", {
			params,
		});
		return res?.data?.data;
	};

	return useQuery(
		["books", "trending", queryParams?.period],
		() => fetch(),
		{
			...fetchConfig,
		}
	);
};

export default useTrendingBooks;
